module.exports = __webpack_public_path__ + "media/images/pc/page_common/purpose_spot-fa5075817bda8a630ffea53ad7083eca.png";